<template>
  <div id="talk">
    <div class="talk-no" v-if="!isTalk">
      <div class="talk-no-icon">
          <img  src="../../../assets/img/talk.png"/>
          <div class="public-talk">快来发表留言</div>
      </div>
    </div>
    <div v-if="isTalk" style="display:flex;flex-direction: column;"> <!-- <div style="height: 7rem;min-height: auto;"> -->
    
      <div class="talk-content" >

        <div class="talk-content-line" v-for="item in talkData">
          <div class="title" >
            <img  v-if="item.headImgUrl" :src="item.headImgUrl"/>
            <img  v-else src="../../../assets/img/defaultTitle.png"/>
          </div>
          <div class="content" >
            <div class="teacher">{{ item.nickName }}</div>
            <div class="time">{{ item.publishTime }}</div>
            <div class="desc">{{ item.content }} </div>
          </div>
        </div>
        <!-- <div class="talk-content-line">
          <div class="title" >
            <img src="../../../assets/img/talk.png"/>
          </div>
          <div class="content" >
            <div class="teacher">大咖老师</div>
            <div class="time">2019-09-20</div>
            <div class="desc">若列表数据加载失败，将error设置成true即可显示错误提示，用户点击错误提示后会重新触发 load 事件。</div>
          </div>
        </div> -->
          <!-- <div class="box3">自适应宽度高度</div> -->
      </div>  
        
    </div>
    <div class="parent" >
          <ul>
            <li>
              <div>            
                <!-- <img src="../../../assets/img/public-course/public-talk.png"/>
                <span>登录用户昵称</span> -->
              </div>
            </li>
            <li >
              <div  @click="goDown">去APP留言</div>
            </li>
          </ul>
        </div>
   
  </div>
</template>     
<script>
import request from '@/utils/request'
export default {
  data(){   
    return{
      defaultImg:request('../../../assets/img/defaultTitle.png'),
      isTalk:true,//false
      talkData:[
        // {nickName:'1234', publishTime:'3456',content:"dfgdddsf",headImgUrl:''}
      ],//留言数据
      courseId: '623873889218330624', //课程id
			category: '2', //课程分类类型
    }
  },
  created() {//622824536466784256/2
    this.courseId = this.$root.getUrlParms("courseId")||'';//623873889218330624
		this.category = this.$root.getUrlParms("category")||2;
		this.channel = this.$root.getUrlParms("channel")||1;//默认为分享页1  wap页 2
    this.initData();
  },
  methods:{
    initData() {
      let _this = this;
      //let url = Global.env + Global.apiCore.subsystemEnterprises+"/"+this.relationId; 
      let url = Global.env +  Global.apiCore.commentData+ "/"+ this.courseId + "/" + 2;
      return new Promise((resolve, reject) => {
        console.log(_this.tableParams)
        request({
          url: url,
          method: 'get',//查询一般为get
        }).then(response => {          
          if (response.resultCode === "1000") {
						this.loading = false;
            if (response && response.data) {
                _this.talkData = response.data;
                // _this.talkData = [];
                if(_this.talkData.length){
                  this.isTalk = true;
                }else{
                  this.isTalk = false;
                }
            }
             return resolve()
          }else{
           
            return reject(response.resultDesc);
          }
        }).catch(error => {
            
            return reject(error);
        })
      })
    },
    goDown() {
      this.$root.download();
    }
  }
}
</script>

<style lang="scss" scope>
  #talk{
    text-align: left;
    .talk-content{
      display: -webkit-flex;
      display: flex;
      flex-wrap: wrap;
      // flex:1;
      padding: 0 .3rem;
      box-shadow: 0px 1px 6px 1px #e3e1e1;
      border-radius: 8px;
      width: 6.4rem;
      margin: .2rem auto 1rem;
      // height: 6.7rem; //临时停用
      overflow: auto;
      .talk-content-line{
        padding: .3rem 0rem;
        padding-bottom: .2rem;
        border-bottom: 0.01rem solid #f7f8fa;
      }
      .title{
        width:1rem;
        & img{
          float: left;
          margin-top: .08rem;
          width:.6rem;
          height: .6rem;
          border-radius: 50%;
        }
      }
      .content{
        margin-left: 1rem;
        .teacher{
          font-size: .3rem;
          color: #333;
        }
        .time{
          font-size: .24rem;
          color: #BDBDBD;
        }
        .desc{
          font-size: .28rem;
          width: 5.4rem;
          color: #666;
        }
      }
      .box3{
        font-size: .3rem;
        flex: auto;
        margin-top: 10px;
        background-color: blue;
      }
    }
    .parent{
			overflow: hidden;
      position:fixed;
			left: 50%;
      bottom: 0;
			transform: translate(-50%,0);
      background: #fff;
      box-shadow: 0 -0.04rem 0.04rem -2px #e3e1e1;
      height: 1rem;
      font-size: .32rem;
      width: 7.5rem;
      ul{
        display: flex;
      }
      ul>li{
        flex:1;
        & div{
          display: flex;//以下三行图文完美局中
          justify-content: center;
          align-items: center;
        }
        & img{
          width: .46rem;
          height: .5rem;
          margin: .26rem 0 .26rem -.6rem;
        }
        & span{
          margin-left: .2rem;
        }
      }
      ul>li:nth-child(2){
        & div{
          float: right;
          margin: .16rem .2rem;
          color: #fff;
          text-align: center;
          background: linear-gradient(bottom, #F63C45, #FF979C);
          width: 2rem;
          height: .7rem;
          border-radius: .5rem;
          line-height: .7rem;
        }
      }
    }
    .parent1{
      position: fixed;
      bottom: 0;
      //display: flex;
      flex-flow:row;/*伸缩项目单行排列*/ 
      background: #fff;
      height: 1rem;
      align-items: center;
      //box-shadow: 0px -3px 3px #e3e1e1;
      box-shadow: 0 -0.04rem 0.04rem -2px #e3e1e1;
      .parent-name1{
        // flex:0 0 2rem;// 固定宽度 2rem 
        // display: flex;//以下三行图文完美局中
        // justify-content: center;
        //align-items: center;
        font-size: .32rem;
        color: #4E4E4E;
        margin-top: .1rem;
        & img{
          width: .46rem;
          height: .5rem;
          margin-left: .26rem;
        }
        & span{
          margin-left: .2rem;
        }
      }
      .parent-talk1{
        // flex: 1; //宽带等比例分配
        font-size: .32rem;
        margin-left: auto;
        margin-right: 20px;
        color: #fff;
        text-align: center;
				background: linear-gradient(bottom, #F63C45, #FF979C);
				width: 1.52rem;
				height: .7rem;
        border-radius: .5rem;
        line-height: .7rem;
        //margin-top: .1rem;
      }
    }
    .talk-no{
      width: 7rem;
      height: 5rem;
      font-size: .30rem;
      text-align: left;
      margin: .2rem auto;
      border-radius: 8px;
      box-shadow: 0px 0px 0.4rem #e3e1e1;
      .talk-no-icon{
        position: absolute;
        left: 48%;
        top: 46%;
        .public-talk{
          margin-left: -33%;
        }
        & img{
          width: .54rem;
          height: .5rem;
        }
      }
    }
  }
</style>